import { render, staticRenderFns } from "./FollowCaseButton.vue?vue&type=template&id=0a45dd30&scoped=true&"
import script from "./FollowCaseButton.vue?vue&type=script&lang=js&"
export * from "./FollowCaseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45dd30",
  null
  
)

export default component.exports